import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { z } from "zod"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function getFieldErrors(errors: { path: (string | number)[]; message: string }[] | undefined, field: string) {
    const filteredErrors = errors?.filter((error) => error?.path[0] == field)

    if (filteredErrors && filteredErrors.length > 0) {
        return filteredErrors[0].message
    }
    return null
}

export function parseIssues(issues: z.ZodIssue[]) {
    return issues.map((issue) => ({
        path: issue.path,
        message: issue.message,
    }))
}

export function capitalize(string: string | undefined) {
    if (!string) {
        return ""
    }
    string = string.replaceAll("_", " ")
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const phoneRegex = new RegExp(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/) // copied from vplan source

export function updateSearchParams(
    searchParams: URLSearchParams,
    changes: Record<string, string | number | undefined>[]
) {
    const newSearchParams = new URLSearchParams(searchParams)
    for (const change of changes) {
        for (const [key, value] of Object.entries(change)) {
            if (value === undefined) {
                newSearchParams.delete(key)
            } else {
                newSearchParams.set(key, String(value))
            }
        }
    }
    return newSearchParams
}

export function getPaginationParams(request: Request) {
    const url = new URL(request.url)
    const limit = Number(url.searchParams.get("limit")) || 10
    const offset = Number(url.searchParams.get("offset")) || 0

    return { limit, offset }
}
